import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RelatedServices = ({ currentService }) => {
  const relatedServices = [
    {
      id: 'ai-models',
      title: 'Custom AI Models',
      description: 'Develop tailored AI solutions that address your specific business challenges and requirements.',
      icon: 'Brain',
      image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=400&h=250&fit=crop',
      features: ['Machine Learning', 'Deep Learning', 'NLP Processing']
    },
    {
      id: 'analytics',
      title: 'Advanced Analytics',
      description: 'Transform your data into actionable insights with our comprehensive analytics solutions.',
      icon: 'BarChart3',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop',
      features: ['Data Visualization', 'Predictive Analytics', 'Real-time Dashboards']
    },
    {
      id: 'cybersecurity',
      title: 'AI-Powered Security',
      description: 'Protect your organization with intelligent cybersecurity solutions and threat detection.',
      icon: 'Shield',
      image: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=400&h=250&fit=crop',
      features: ['Threat Detection', 'Security Automation', 'Risk Assessment']
    }
  ].filter(service => service.id !== currentService.id);

  return (
    <div className="py-16 bg-muted/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-foreground mb-4">
            Related Services
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Explore our other AI and technology solutions that complement your current needs
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {relatedServices.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-soft border border-border overflow-hidden hover:shadow-elevation transition-smooth">
              <div className="aspect-[16/10] overflow-hidden">
                <Image 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              
              <div className="p-6">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-10 h-10 rounded-full gradient-primary flex items-center justify-center">
                    <Icon name={service.icon} size={20} color="white" />
                  </div>
                  <h3 className="text-xl font-semibold text-foreground">
                    {service.title}
                  </h3>
                </div>
                
                <p className="text-muted-foreground mb-4 leading-relaxed">
                  {service.description}
                </p>
                
                <div className="space-y-2 mb-6">
                  {service.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center space-x-2">
                      <Icon name="Check" size={14} className="text-success" />
                      <span className="text-sm text-muted-foreground">{feature}</span>
                    </div>
                  ))}
                </div>
                
                <div className="flex space-x-3">
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={() => window.location.href = '/individual-service-detail'}
                  >
                    Learn More
                  </Button>
                  <Button 
                    variant="default" 
                    size="sm"
                    iconName="Calendar"
                    iconPosition="left"
                    onClick={() => window.location.href = '/contact-consultation-request'}
                  >
                    Discuss
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link 
            to="/services-overview"
            className="inline-flex items-center space-x-2 text-primary hover:text-secondary font-semibold transition-smooth"
          >
            <span>View All Services</span>
            <Icon name="ArrowRight" size={18} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RelatedServices;